
import Vue from 'vue'
import RButton from '@/components/forms/RButton.vue'

export default Vue.extend({
  name: 'PlaceholderWithButton',
  components: {
    RButton,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
    buttonDisabled: {
      type: Boolean,
      default: false,
    },
    img: {
      type: String,
      default: 'start-building',
    },
  },
  methods: {
    handleCTAClick() {
      this.$emit('button-click')
    },
  },
})
